'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureStore;

var _redux = require('redux');

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reduxPromise = require('redux-promise');

var _reduxPromise2 = _interopRequireDefault(_reduxPromise);

var _middleware = require('@its/components/lib/middleware');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function configureStore(_ref) {
  var initialState = _ref.initialState;
  var _ref$reducer = _ref.reducer;
  var reducer = _ref$reducer === undefined ? {} : _ref$reducer;
  var _ref$middleware = _ref.middleware;
  var middleware = _ref$middleware === undefined ? [] : _ref$middleware;

  middleware = middleware.concat([_reduxThunk2.default, _reduxPromise2.default, _middleware.router]);
  if (process.env.enableLogger) {
    var createLogger = require('redux-logger');
    middleware.push(createLogger());
  }
  var createStoreWithMiddleware = _redux.applyMiddleware.apply(this, middleware)(_redux.createStore);

  var store = createStoreWithMiddleware(reducer, initialState);

  /*
    // Insert this in app index.js after store declaration
    // Debug, hot load
    if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./reducer', () => {
      const nextReducer = require('./reducer');
      store.replaceReducer(nextReducer);
    });
  }
  */

  return store;
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/redux/lib/configureStore.js
 ** module id = 509
 ** module chunks = 0
 **/